module.exports = __webpack_public_path__ + "media/images/logo_small-9fb8f2acd3cf3ead49242f87d14c94f6.jpeg";